/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { ModalRoute } from 'react-router-modal';
import axios from 'axios';
import { updateBookingField } from '../../../../actions/Bookings';
import { ROOT_URL_V2, getCSRFToken } from '../../../../config';

import BookingDetailsChargesWidget from './BookingDetailsChargesWidget';
import './bookingDetailsPrice.scss';

import history from '../../../../history';

const propTypes = {
    job: PropTypes.object.isRequired,
    relevantJobId: PropTypes.object.isRequired,
    notification: PropTypes.object.isRequired,
    table: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

class BookingDetailsPrice extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            client_pay_per_hour: this.props.job.booking.client_pay_per_hour,
            freelancer_pay_per_hour: this.props.job.booking.freelancer_pay_per_hour,
            breaks: this.props.job.booking.breaks,
        };
    }

    handleOnChange = ({ target: { id, value } }) => {
        if (id === 'breaks') {
            this.setState({ [id]: Math.floor(parseFloat(value)) });
        } else {
            this.setState({ [id]: parseFloat(value) });
        }
    };

    handleBlur = event => {
        this.handleSubmit();
    };

    handleOnKeyPress = event => {
        const KEY_CODE_ENTER = 13;
        if (
            event.nativeEvent.which === KEY_CODE_ENTER ||
            event.nativeEvent.keyCode === KEY_CODE_ENTER
        ) {
            event.target.blur();
        }
    };

    handleFormSubmit = formValues => {
        this.setState({ isLoading: true });
        axios({
            method: 'PATCH',
            url: `${ROOT_URL_V2}jobs/${this.props.relevantJobId}/bookings/${this.props.job.booking.id}/`,
            data: formValues,
            headers: {
                'X-CSRFToken': getCSRFToken(),
            },
        })
            .then(response => {
                this.props.updateBookingField({
                    id: this.props.job.booking.id,
                    jobId: this.props.job.id,
                    data: response.data.content,
                });
                this.setState({ isLoading: false });
                this.props.notification.success(
                    'Success',
                    `Job ${response.data.content.reference_number} successfully edited`,
                );
            })
            .catch(error => {
                this.setState({
                    isLoading: false,
                    client_pay_per_hour:
                        this.props.job.booking.client_pay_per_hour,
                    freelancer_pay_per_hour:
                        this.props.job.booking.freelancer_pay_per_hour,
                    breaks: this.props.job.breaks,
                });
                if (error) {
                    if (!error.response || !error.response.data) {
                        this.setState({
                            errorMessage:
                                'Network error, please check your connection',
                        });
                    } else if (
                        error.response.data.meta.detail.non_field_errors
                    ) {
                        this.setState({
                            errorMessage:
                                error.response.data.meta.detail.non_field_errors.join(
                                    ', ',
                                ),
                        });
                    } else {
                        this.setState({
                            errorMessage: JSON.stringify(
                                error.response.data.meta.detail,
                            ),
                        });
                    }
                }
            });
    };

    handleSubmit = () => {
        const formData = {
            client_pay_per_hour: this.state.client_pay_per_hour,
            freelancer_pay_per_hour: this.state.freelancer_pay_per_hour,
            breaks: this.state.breaks,
        };

        if (formData.freelancer_pay_per_hour === null) {
            delete formData.freelancer_pay_per_hour;
        }
        if (formData.client_pay_per_hour === null) {
            delete formData.client_pay_per_hour;
        }
        if (
            (this.state.client_pay_per_hour &&
                this.state.client_pay_per_hour !=
                    this.props.job.booking.client_pay_per_hour) ||
            (this.state.freelancer_pay_per_hour &&
                this.state.freelancer_pay_per_hour !=
                    this.props.job.booking.freelancer_pay_per_hour) ||
            this.state.breaks != this.props.job.booking.breaks
        ) {
            this.handleFormSubmit(formData);
        }
    };

    render() {
        const { job, user } = this.props;
        const clientRate = this.state.client_pay_per_hour;
        const workerRate = this.state.freelancer_pay_per_hour;
        const clientCharges = job.booking.client_total_additional_charges;
        const workerCharges = job.booking.freelancer_total_additional_charges;
        const clientTotal = job.booking.client_total_cost;
        const workerTotal = job.booking.freelancer_total_pay;
        const breaks = this.state.breaks;

        const isDelegatedJob =
            user.isAgent && user.agency.id !== job.managing_agency_details.id;
        const isManagedJob =
            user.isAgent && user.agency.id === job.managing_agency_details.id;
        const isManager =
            this.props.clientData.userData.content.permissions.includes(
                'auth.manage_postjob_ops',
            );
        const isSelfManagedClient =
            user.isAgent && user.agency.features.includes('self_managed');

        const showClientRate = !isSelfManagedClient || clientRate;
        const clientRateLabel =
            user.isClient || isDelegatedJob
                ? 'Buzzhire rate'
                : isSelfManagedClient
                ? 'Venue rate'
                : 'Client rate';
        const showWorkerRate = isManagedJob;
        const editRates = isManager && isManagedJob;

        return (
            <div className="booking-details-price">
                <div className="booking-details-price__column">
                    {showClientRate && (
                        <div className="booking-details-price__cell rate-form-field">
                            <label className="booking-details-price__title">
                                {clientRateLabel}
                            </label>
                            {isNaN(clientRate) ? (
                                <div className="booking-details-main">N/A</div>
                            ) : editRates ? (
                                <div className="inputWrapper">
                                    <input
                                        type="number"
                                        step="0.25"
                                        min="0"
                                        id="client_pay_per_hour"
                                        className="input-focus"
                                        value={clientRate.toFixed(2)}
                                        onChange={this.handleOnChange}
                                        onBlur={this.handleBlur}
                                        onKeyPress={this.handleOnKeyPress}
                                        disabled={this.state.isLoading}
                                    />
                                    <i className="icon icon-pencil-2" />
                                </div>
                            ) : (
                                <div className="booking-details-main">
                                    £{clientRate.toFixed(2)} /h
                                </div>
                            )}
                        </div>
                    )}
                    {showWorkerRate && (
                        <div className="booking-details-price__cell rate-form-field">
                            <label className="booking-details-price__title">
                                Worker rate
                            </label>
                            {isNaN(clientRate) ? (
                                <div className="booking-details-main">N/A</div>
                            ) : editRates ? (
                                <div className="inputWrapper">
                                    <input
                                        type="number"
                                        step="0.25"
                                        min="0"
                                        id="freelancer_pay_per_hour"
                                        value={workerRate?.toFixed(2)}
                                        onChange={this.handleOnChange}
                                        onBlur={this.handleBlur}
                                        onKeyPress={this.handleOnKeyPress}
                                        disabled={this.state.isLoading}
                                    />
                                    <i className="icon icon-pencil-2" />
                                </div>
                            ) : (
                                <div className="booking-details-main">
                                    £{workerRate?.toFixed(2)} /h
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <div className="booking-details-price__column">
                    {showClientRate ? (
                        <div className="booking-details-price__cell">
                            <div className="booking-details-price__title">
                                Charges
                            </div>
                            {editRates ? (
                                <NavLink
                                    to={`${this.props.location.pathname}charges/${this.props.location.search}`}
                                    className="booking-details-main"
                                >
                                    {isNaN(clientCharges)
                                        ? 'N/A'
                                        : `£${clientCharges.toFixed(2)}`}
                                </NavLink>
                            ) : (
                                <div className="booking-details-main">
                                    {isNaN(clientCharges)
                                        ? 'N/A'
                                        : `£${clientCharges.toFixed(2)}`}
                                </div>
                            )}
                        </div>
                    ) : null}
                    {showWorkerRate ? (
                        <div className="booking-details-price__cell">
                            <div className="booking-details-price__title">
                                Charges
                            </div>
                            {editRates ? (
                                <NavLink
                                    to={`${this.props.location.pathname}charges/${this.props.location.search}`}
                                    className="booking-details-main"
                                >
                                    {isNaN(workerCharges)
                                        ? 'N/A'
                                        : `£${workerCharges.toFixed(2)}`}
                                </NavLink>
                            ) : (
                                <div className="booking-details-main">
                                    {isNaN(workerCharges)
                                        ? 'N/A'
                                        : `£${workerCharges.toFixed(2)}`}
                                </div>
                            )}
                        </div>
                    ) : null}
                    {editRates && (
                        <ModalRoute
                            id={job.booking.id}
                            path={`${this.props.match.path}/charges/`}
                            component={BookingDetailsChargesWidget}
                            props={{
                                job,
                                relevantJobId: this.props.relevantJobId,
                                notification: this.props.notification,
                                table: this.props.table,
                            }}
                            onBackdropClick={() => {
                                const pathname =
                                    this.props.location.pathname.replace(
                                        '/charges',
                                        '',
                                    );
                                history.push(
                                    pathname + this.props.location.search,
                                );
                            }}
                        />
                    )}
                </div>

                <div className="booking-details-price__column">
                    {showClientRate && (
                        <div className="booking-details-price__cell">
                            <div className="booking-details-price__title">
                                Total
                            </div>
                            <div className="booking-details-price__value">
                                {isNaN(clientTotal)
                                    ? 'N/A'
                                    : `£${clientTotal?.toFixed(2)}`}
                            </div>
                        </div>
                    )}
                    {showWorkerRate && (
                        <div className="booking-details-price__cell">
                            <div className="booking-details-price__title">
                                Worker pay
                            </div>
                            <div className="booking-details-price__value">
                                {isNaN(clientTotal)
                                    ? 'N/A'
                                    : `£${workerTotal?.toFixed(2)}`}
                            </div>
                        </div>
                    )}
                </div>
                <div className="booking-details-price__cell rate-form-field">
                    <label
                        className="booking-details-price__title"
                        htmlFor="breaks"
                    >
                        Break
                    </label>
                    <div className="breaks-wrapper">
                        <input
                            type="number"
                            step="1"
                            min="0"
                            id="breaks"
                            className="input-focus"
                            value={breaks}
                            onChange={this.handleOnChange}
                            onBlur={this.handleBlur}
                            onKeyPress={this.handleOnKeyPress}
                            disabled={this.state.isLoading}
                        />
                        <i className="icon icon-pencil-2" />
                    </div>
                </div>
            </div>
        );
    }
}

BookingDetailsPrice.propTypes = propTypes;

function mapStateToProps(state) {
    return {
        clientData: state.clientData,
        user: state.user,
    };
}

export default connect(mapStateToProps, { updateBookingField })(
    BookingDetailsPrice,
);
